
export const isPercentageValue = (val) => {
  const num = Number(val);
  return num >= 0 && num <= 100;
};

export const Tabs = {
  CHOSEN_OPTIONS: 'chosenOptions',
  EXTRA_INFORMATION: "extraInformation",
  EXTRA_INFORMATION_LIMITED: "extraInformationLimited",
  FINAL_BUDGET: "finalBudget",
  TECH_INFO: "techInfo"
};

export const SectionKeys = {
  GENERAL: 'GENERAL',
  COMMERCIAL_DESCRIPTION: 'COMMERCIAL_DESCRIPTION',
  SALES_PRICE: 'SALES_PRICE',
  PURCHASE_PER_UNIT: 'PURCHASE_PER_UNIT',
  SALES_TOTAL: 'SALES_TOTAL',
  TECH_INFO :'TECH_INFO'
};

export const QUESTION_TYPE = {
  SELECT: "SELECT",
  NUMBER: "NUMBER",
  TEXT: "TEXT",
  TEXTAREA: "TEXTAREA",
  CHECKBOX: "CHECKBOX"
}

export const getFormFields = (t,value) => {
  console.log({value})
  return [
  {
    dutchId: 'werk_guid',
    fieldId:"projectId",
    label: t('general.project'),
    questionType: QUESTION_TYPE.TEXT,
    defaultValue: value?.project ?? "",
    
    isHidden:false,
    disable: true,
    rules:{
      required: true,
    },
    fieldDisplayPosition: Tabs.CHOSEN_OPTIONS + "." + SectionKeys.GENERAL,
    keyName: 'project',
  },
  {
    dutchId: 'gebouw_guid',
    fieldId:"buildingId",
    label: t('general.object'),
    questionType: QUESTION_TYPE.TEXT,
    defaultValue: value?.object ?? "",
    rules:{
      required: true,
    },
    
    isHidden:false,
    disable: true,
    fieldDisplayPosition: Tabs.CHOSEN_OPTIONS + "." + SectionKeys.GENERAL,
    keyName: 'object',
  },
  {
    dutchId: 'soort',
    fieldId:"type",
    label: t('general.type'),
    questionType: QUESTION_TYPE.TEXT,
    rules:{
      required: true,
    },
    
    isHidden:false,
    disable: true,
    defaultValue:t('buyersGuide.options.individual'),
    fieldDisplayPosition: Tabs.CHOSEN_OPTIONS + "." + SectionKeys.GENERAL,
    keyName: 'type',
  },
  {
    dutchId: 'optienummer',
    fieldId:"optionNumber",
    label: t('buyersGuide.standardOptions.optionNumber'),
    rules:{
      required:`${t('buyersGuide.standardOptions.optionNumber')} is required`,
      maxLength:15,
    },
    defaultValue: value?.optionNumber ?? "",
    
    isHidden: false ,
    disable: false ,
    fieldDisplayPosition: Tabs.CHOSEN_OPTIONS + "." + SectionKeys.GENERAL,
    keyName: 'optionNumber',
  },
  {
    dutchId: 'omschrijving',
    fieldId:"description",
    label: t('general.description'),
    questionType: QUESTION_TYPE.TEXT,
    rules:{
      required:`${t('general.description')} is required`,
      maxLength:80,
    },
    isHidden: false ,
    defaultValue: value?.description ?? "",
    
    disable: false ,
    fieldDisplayPosition: Tabs.CHOSEN_OPTIONS + "." + SectionKeys.GENERAL,
    keyName: 'description',
  },
  {
    dutchId: 'optie_rubriek_werk_guid',
    fieldId:"projectHeaderId",
    label: t('general.header'),
    questionType: QUESTION_TYPE.SELECT,
    selectOptions: value?.headerOptions  || [],
    defaultValue: value?.projectHeaderId,
    rules:{
      required: `${t('general.header')} is required`,
    },
    isHidden: false ,
    
    disable: false ,
    fieldDisplayPosition: Tabs.CHOSEN_OPTIONS + "." + SectionKeys.GENERAL,
    keyName: 'projectHeaderId',
  },
  {
    dutchId: 'optie_categorie_werk_guid ',
    fieldId:"projectCategoryId",
    label: t('general.category'),
    questionType: QUESTION_TYPE.SELECT,
    selectOptions: value?.categoryOptions  || [],
    defaultValue: value?.projectCategoryId,
    rules:{
      required: `${t('general.category')} is required`,
    },
    isHidden: false ,
    
    disable: false ,
    fieldDisplayPosition: Tabs.CHOSEN_OPTIONS + "." + SectionKeys.GENERAL,
    keyName: 'projectCategoryId',
  },
  {
    dutchId: 'aantal ',
    fieldDisplayPosition: Tabs.CHOSEN_OPTIONS + "." + SectionKeys.GENERAL,
    groupItems: {
      id: "aantal",
      questions: [
        {
          dutchId: 'aantal ',
          fieldId:"quantity",
          label: t('buyersGuide.options.individualOption.quantity'),
          isHidden: false,
          disable: false,
          defaultValue: value?.quantity ?? "",
          rules:{
            required: `${t('buyersGuide.options.individualOption.quantity')} is required`, 
            },
          
         fieldDisplayPosition: Tabs.CHOSEN_OPTIONS + "." + SectionKeys.GENERAL,
          keyName:"quantity",
          questionType: QUESTION_TYPE.NUMBER,
          sizes:{xs: 5, sm:4, md: 4}
        },
        {
          dutchId: 'eenheid_guid ',
          fieldId:"unitId",
          label: t('buyersGuide.options.individualOption.unitType'),
          questionType: QUESTION_TYPE.SELECT,
          selectOptions: value?.unitOptions   || [],
          defaultValue: value?.unitId,
          rules: {
            required: false,
          },
          isHidden: false,
          
          disable: false,
          keyName: 'unitId',
          sizes:{xs: 7, sm: 8, md: 8}
        },
      ]
    },
  },
  {
    dutchId: 'optie_status',
    fieldId:"status",
    label: t('general.status'),
    questionType: QUESTION_TYPE.TEXT,
    disable: true,
    rules:{
      required: `${t('general.status')} is required`,
    },
    defaultValue:t('buyersGuide.options.individualOption.provisional'),
    isHidden: false,
    
    fieldDisplayPosition: Tabs.CHOSEN_OPTIONS + "." + SectionKeys.GENERAL,
    keyName: 'optionStatus',
  },
  {
    dutchId: 'optie_substatus',
    fieldId:"substatus",
    label: t('buyersGuide.options.individualOption.chosenOption.subStatus'),
    questionType: QUESTION_TYPE.TEXT,
    defaultValue:t('buyersGuide.options.individualOption.inShoppingCart'),
    disable:true,
    rules:{
      required: false,
    },
    isHidden: false,  
    
    fieldDisplayPosition: Tabs.CHOSEN_OPTIONS + "." + SectionKeys.GENERAL,
    keyName: 'subStatus',
  },
  //SECOND PART FIRST TAB
  {
    dutchId: 'commerciele_omschrijving',
    fieldId:"commercialDescription",
    label: t('buyersGuide.options.individualOption.commercialDescriptionTitle'),
    questionType: QUESTION_TYPE.TEXTAREA,
    rules:{
      required:false,
    },
    isHidden: false,
    
    disable:false,
    fieldDisplayPosition: Tabs.CHOSEN_OPTIONS + "." + SectionKeys.COMMERCIAL_DESCRIPTION,
    keyName: 'commercialDescription',
    sizes:{xs: 12, sm: 12, md: 12}
  },
  {
    dutchId: 'commerciele_omschrijving_op_meterkastlijst',
    fieldId:"commercialDescriptionOnMeterCabinetList",
    label: t('buyersGuide.options.individualOption.commercialOnMeterCupboard'),
    questionType: QUESTION_TYPE.CHECKBOX,
    defaultValue:value?.commercialDescriptionOnMeterCabinetList ?? false,
    isHidden: false,
    
    disable:false,
    fieldDisplayPosition: Tabs.CHOSEN_OPTIONS + "." + SectionKeys.COMMERCIAL_DESCRIPTION,
    keyName: 'commercialDescriptionOnMeterCabinetList',
    sizes:{xs: 12, sm: 12, md: 12}
  },
  {
    dutchId: 'technische_omschrijving',
    fieldId:"technicalDescription",
    label: t('buyersGuide.options.individualOption.technicalDescription'),
    questionType: QUESTION_TYPE.TEXTAREA,
    rules:{
      required: false,
    },
    isHidden: false,
    
    disable:false,
    fieldDisplayPosition: Tabs.CHOSEN_OPTIONS + "." + SectionKeys.COMMERCIAL_DESCRIPTION,
    keyName: 'technicalDescription',
    sizes:{xs: 12, sm: 12, md: 12}
  },
  {
    dutchId: 'technische_omschrijving_op_meterkastlijst',
    fieldId:"technicalDescriptionOnMeterCabinetList",
    label: t('buyersGuide.options.individualOption.technicalOnMeterCupboard'),
    questionType: QUESTION_TYPE.CHECKBOX,
    defaultValue:value?.technicalDescriptionOnMeterCabinetList ?? false,
    isHidden: false,
    
    disable:false,
    fieldDisplayPosition: Tabs.CHOSEN_OPTIONS + "." + SectionKeys.COMMERCIAL_DESCRIPTION,
    keyName: 'technicalDescriptionOnMeterCabinetList',
    sizes:{xs: 12, sm: 12, md: 12}
  },

  // SECOND TAB 
  {
    dutchId: 'verkoopprijs_ntb',
    fieldId:"salesPriceToBeDetermined",
    label: t('buyersGuide.options.individualOption.ntb'),
    questionType: QUESTION_TYPE.CHECKBOX,
    defaultValue:value?.salesPriceToBeDetermined ?? false,
    isHidden: false,
    
    disable:false,
    fieldDisplayPosition: Tabs.EXTRA_INFORMATION,
    keyName: 'salesPriceToBeDetermined',
  },
  {
    dutchId: 'verkoopprijs_is_stelpost',
    fieldId:"budgetItem",
    label: t('buyersGuide.options.individualOption.budgetItem'),
    questionType: QUESTION_TYPE.CHECKBOX,
    defaultValue:value?.budgetItem ?? false,
    isHidden: false,
    
    disable:false,
    fieldDisplayPosition: Tabs.EXTRA_INFORMATION,
    keyName: 'budgetItem',
  },
  {
    dutchId: 'TekstPrijskolomGuid',
    fieldId: 'textPriceColumnId',
    label: t('buyersGuide.options.individualOption.textPriceColumn'),
    questionType: QUESTION_TYPE.SELECT,
    selectOptions: value?.textPriceListOptions   || [],
    defaultValue: value?.textPriceColumnId,
    rules:{
      required:true,
    },
    isHidden: true,
    
    disable:false,
    fieldDisplayPosition: Tabs.EXTRA_INFORMATION,
    keyName: 'textPriceColumnId',
    dependantConditions:{
      conditions:[{keyName:"budgetItem" , value : true } , {keyName:"salesPriceToBeDetermined" , value : true } ],
      operator:"OR"
    }
  },
  {
    dutchId: 'factureren ',
    fieldId:"toInvoice",
    label: t('buyersGuide.options.individualOption.invoice'),
    questionType: QUESTION_TYPE.CHECKBOX,
    defaultValue:value?.toInvoice ?? false,
    isHidden: false,
    
    disable:false,
    fieldDisplayPosition: Tabs.EXTRA_INFORMATION,
    keyName: 'toInvoice',
  },
  {
    dutchId: 'via_website ',
    fieldId:"viaWebsite",
    label: t('buyersGuide.options.individualOption.viaWebsite'),
    questionType: QUESTION_TYPE.CHECKBOX,
    defaultValue:value?.viaWebsite ?? false,
    isHidden: false,
    
    disable: true,
    fieldDisplayPosition: Tabs.EXTRA_INFORMATION,
    keyName: 'viaWebsite',
  },
  {
    dutchId: 'op_tekening_verwerkt ',
    fieldId:"processedOnDrawing",
    label: t('buyersGuide.options.individualOption.processOnDrawing'),
    questionType: QUESTION_TYPE.CHECKBOX,
    defaultValue:value?.processedOnDrawing ?? false,
    isHidden: false,
    
    disable: false,
    fieldDisplayPosition: Tabs.EXTRA_INFORMATION,
    keyName: 'processedOnDrawing',
  },
  {
    dutchId: 'gecontroleerd ',
    fieldId:"verified",
    label: t('buyersGuide.options.individualOption.checked'),
    questionType: QUESTION_TYPE.CHECKBOX,
    defaultValue:value?.verified ?? false,
    isHidden: false,
    
    disable: false,
    fieldDisplayPosition: Tabs.EXTRA_INFORMATION,
    keyName: 'verified',
  },
  {
    dutchId: 'toon_optie_in_meterkastlijst ',
    fieldId:"showOptionInMeterCabinetList",
    label: t('buyersGuide.options.individualOption.showInMaterialList'),
    questionType: QUESTION_TYPE.CHECKBOX,
    defaultValue:value?.showOptionInMeterCabinetList ?? false,
    isHidden: false,
    
    disable: false,
    fieldDisplayPosition: Tabs.EXTRA_INFORMATION,
    keyName: 'showOptionInMeterCabinetList',
  },
  {
    dutchId: 'gelimiteerde_garantie',
    fieldId:"limitedWarranty",
    label: t('buyersGuide.options.individualOption.limitedWarranty'),
    questionType: QUESTION_TYPE.CHECKBOX,
    defaultValue:value?.limitedWarranty ?? false,
    isHidden: false,
    
    disable: false,
    fieldDisplayPosition: Tabs.EXTRA_INFORMATION_LIMITED,
    keyName: 'limitedWarranty',
  },
  {
    dutchId: 'toelichtingGelimiteerdeGarantie',
    fieldId:"limitedWarrantyExplanation",
    label: t('buyersGuide.options.individualOption.limitedWarranty'),
    questionType: QUESTION_TYPE.TEXTAREA,
    defaultValue:value?.limitedWarrantyExplanation,
    isHidden: true,
    
    disable: false,
    fieldDisplayPosition: Tabs.EXTRA_INFORMATION_LIMITED,
    dependantConditions:{
      conditions:[{keyName:"limitedWarranty" , value : true } ],
      operator:"AND"
    },
    keyName: 'limitedWarrantyExplanation',
  },
  {
    dutchId: 'gelimiteerde_garantie',
    fieldId:"limitedWarantyTextId",
    label: t('buyersGuide.options.individualOption.limitedWarranty'),
    questionType: QUESTION_TYPE.SELECT,
    selectOptions: value?.limitedGuaranteeTextOptions   || [],
    defaultValue:value?.limitedWarantyTextId,
    isHidden: true,
    
    disable: false,
    fieldDisplayPosition: Tabs.EXTRA_INFORMATION_LIMITED,
    dependantConditions:{
      conditions:[{keyName:"limitedWarranty" , value : true } ],
      operator:"AND"
    },
    keyName: 'limitedWarantyTextId',
  },


  // THEARD TAB 
  {
    dutchId: 'verkoopprijs_incl_btw',
    fieldId:"salesPriceInclVAT",
    label: t('buyersGuide.standardOptions.salesPriceInclVAT'),
    defaultValue : value?.salesPriceInclVAT,
    questionType: QUESTION_TYPE.NUMBER,
    rules:{
      required: `${t('buyersGuide.standardOptions.salesPriceInclVAT')} is required`,
    },
    isHidden: false,
    
    disable: false,
    fieldDisplayPosition: Tabs.FINAL_BUDGET + "." + SectionKeys.SALES_PRICE,
    keyName: 'salesPriceInclVAT',
    sizes:{xs: 12, sm: 4, md: 4, lg: 4}
  },
  {
    dutchId: 'percentageVAT ',
    fieldDisplayPosition: Tabs.FINAL_BUDGET + "." + SectionKeys.SALES_PRICE,
    groupItems: {
      id: "percentageVAT",
      questions: [
        {
          dutchId: 'percentageVAT ',
           fieldId:"percentageVAT",
          label: t('buyersGuide.options.individualOption.vat'),
          isHidden: false,
          
          disable: false,
          defaultValue : value?.percentageVAT ?? 0,
          questionType: QUESTION_TYPE.NUMBER,
          isAllowedFn: isPercentageValue,
          keyName:"percentageVAT",
          sizes:{xs: 4, sm: 2, md: 2, lg: 2}
        },
        {
          dutchId: 'bedrag_btw ',
          label: t('general.price'),
          fieldId:"VATAmount",
          defaultValue : value?.VATAmount,
          questionType: QUESTION_TYPE.NUMBER,
          isHidden: false,
          
          disable: true,
          keyName: 'VATAmount',
          sizes:{xs: 8, sm: 4, md: 4, lg: 4}
        },
      ]
    }
  },
  {
    dutchId: 'verkoopprijs_excl_btw  ',
    fieldId:"salesAmountExclVAT",
    label: t('buyersGuide.standardOptions.salesPriceExclVAT'),
    defaultValue : value?.salesAmountExclVAT ?? 0,
    questionType: QUESTION_TYPE.NUMBER,
    isHidden: false,
    
    disable: true,
    fieldDisplayPosition: Tabs.FINAL_BUDGET + "." + SectionKeys.SALES_PRICE,
    keyName: 'salesAmountExclVAT',
    sizes:{xs: 12, sm: 4, md: 4, lg: 4}
  },
  {
    dutchId: 'omschrijving_toeslag_1 ',
    fieldDisplayPosition: Tabs.FINAL_BUDGET + "." + SectionKeys.SALES_PRICE,
    groupItems: {
      id: "omschrijving_toeslag_1",
      questions: [
        {
          dutchId: 'omschrijving_toeslag_1 ',
          fieldId:'surchargeDescription1',
          label: `${t('buyersGuide.options.individualOption.surcharge')} 1`,
          defaultValue : value?.surchargeDescription1 ?? "",
          isHidden: false,
          
          disable: true,
          keyName:"surchargeDescription1",
          questionType:QUESTION_TYPE.TEXT,
          sizes: { xs: 12, sm: 6, md: 6, lg: 6 },
        },
        {
          dutchId: 'percentage_toeslag_1 ',
          fieldId:'surchargePercentage1',
          label: t('general.per'),
          questionType: QUESTION_TYPE.NUMBER,
          isAllowedFn: isPercentageValue,
          defaultValue : value?.surchargePercentage1 ?? 0,
          isHidden: false,
          
          disable: false,
          keyName: 'surchargePercentage1',
          sizes: { xs: 4, sm: 2, md: 2, lg: 2 },
        },
        {
          dutchId: 'bedrag_toeslag_1 ',
          fieldId:'surchargeAmount1',
          label: t('general.price'),
          defaultValue : value?.surchargeAmount1 ?? 0,
          questionType: QUESTION_TYPE.NUMBER,
          isHidden: false,
          
          disable: true,
          keyName: 'surchargeAmount1',
          sizes: { xs: 8, sm: 4, md: 4, lg: 4 },
        },
      ]
    }
  },
  {
    dutchId: 'omschrijving_toeslag_2 ',
    fieldDisplayPosition: Tabs.FINAL_BUDGET + "." + SectionKeys.SALES_PRICE,
    groupItems: {
      id: "omschrijving_toeslag_2",
      questions: [
        {
          dutchId: 'omschrijving_toeslag_2 ',
          fieldId:'surchargeDescription2',
          label: `${t('buyersGuide.options.individualOption.surcharge')} 2`,
          defaultValue : value?.surchargeDescription2 ?? "",
          isHidden: false,
          
          disable: true,
          keyName:"surchargeDescription2",
          questionType:QUESTION_TYPE.TEXT,
          sizes: { xs: 12, sm: 6, md: 6, lg: 6 },
        },
        {
          dutchId: 'percentage_toeslag_2 ',
          fieldId:'surchargePercentage2',
          label: t('general.per'),
          questionType: QUESTION_TYPE.NUMBER,
          isAllowedFn: isPercentageValue,
          defaultValue : value?.surchargePercentage2 ?? 0,
          isHidden: false,
          
          disable: false,
          keyName: 'surchargePercentage2',
          sizes: { xs: 4, sm: 2, md: 2, lg: 2 },
        },
         {
          dutchId: 'bedrag_toeslag_2 ',
          fieldId:'surchargeAmount2',
          label: t('general.price'),
          defaultValue : value?.surchargeAmount2 ?? 0,
          questionType: QUESTION_TYPE.NUMBER,
          type:'number',
          isHidden: false,
          
          disable: true,
          keyName: 'surchargeAmount2',
          sizes: { xs: 8, sm: 4, md: 4, lg: 4 },
        },
      ]
    }
  },
  {
    dutchId: 'totaal_bedrag_toeslagen ',
    fieldId:'totalSurchargeAmount',
    label: t('buyersGuide.options.individualOption.totalSurcharges'),
    defaultValue : value?.totalSurchargeAmount ?? 0,
    questionType: QUESTION_TYPE.NUMBER,
    isHidden: false,
    
    disable: true,
    fieldDisplayPosition: Tabs.FINAL_BUDGET + "." + SectionKeys.SALES_PRICE,
      keyName: 'totalSurchargeAmount',
    sizes:{xs: 12, sm: 4, md: 4, lg: 4}
  },
  //TODO: customSalesPrice is correct    
  {
    dutchId: 'eigen_verkoopprijs  ',
    fieldId:'customSalesPrice',
    label: t('buyersGuide.options.individualOption.ownSalesPrice'),
    defaultValue : value?.customSalesPrice ?? 0,
    questionType: QUESTION_TYPE.NUMBER,
    isHidden: false,
    
    disable: true,
    fieldDisplayPosition: Tabs.FINAL_BUDGET + "." + SectionKeys.SALES_PRICE,
    keyName: 'customSalesPrice',
    sizes:{xs: 12, sm: 4, md: 4, lg: 4}
  },
  /// SECOND PART 
  {
    dutchId: 'bereken_kale_kostprijs',
     fieldId:'calculateBaseCostPrice',
    label: t('buyersGuide.options.individualOption.calculateNetCostPrice'),
    defaultValue : value?.calculateBaseCostPrice ?? false,
    questionType: QUESTION_TYPE.CHECKBOX,
    isHidden: false,
    
    disable: false,
    fieldDisplayPosition: Tabs.FINAL_BUDGET + "." + SectionKeys.PURCHASE_PER_UNIT,
    keyName: 'calculateBaseCostPrice',
    sizes:{xs: 10, sm: 10, md: 9, lg: 9},
  },
  {
    dutchId: 'bedrag_kale_kostprijs',
     fieldId:'baseCostAmount',
    label: t('buyersGuide.options.individualOption.bareCostPrice'),
    defaultValue : value?.baseCostAmount ?? 0,
    questionType: QUESTION_TYPE.NUMBER,
    isHidden: false,
    
    disable: true,
    fieldDisplayPosition: Tabs.FINAL_BUDGET + "." + SectionKeys.PURCHASE_PER_UNIT,
    keyName: 'baseCostAmount',
    sizes:{xs: 12, sm: 4, md: 4, lg: 4}
  },
  {
    dutchId: 'omschrijving_kosten_1',
    fieldDisplayPosition: Tabs.FINAL_BUDGET + "." + SectionKeys.PURCHASE_PER_UNIT,
    groupItems: {
      id: "omschrijving_kosten_1",
      questions: [
        {
          dutchId: 'omschrijving_kosten_1',
          fieldId:'costDescription1',
          label: `${t("buyersGuide.options.individualOption.costs")} 1`,
          defaultValue : value?.costDescription1 ?? "",
          isHidden: false,
          
          disable: true,
          keyName:"costDescription1",
          questionType:QUESTION_TYPE.TEXT,
          sizes: { xs: 12, sm: 6, md: 6, lg: 6 },
        },
        {
          dutchId: 'percentage_kosten_1 ',
          fieldId:'costPercentage1',
          label: t('general.per'),
          defaultValue : value?.costPercentage1 ?? 0,
          questionType: QUESTION_TYPE.NUMBER,
          isAllowedFn: isPercentageValue,
         isHidden: false,
         
         disable: false,
          keyName: 'costPercentage1',
          sizes: { xs: 4, sm: 2, md: 2, lg: 2 },
        },
         {
          dutchId: 'bedrag_kosten_1 ',
          fieldId:'costAmount1',
          label: t('general.price'),
          defaultValue : value?.costAmount1 ?? 0,
          questionType: QUESTION_TYPE.NUMBER,
          isHidden: false,
          
          disable: true,
          keyName: 'costAmount1',
          sizes: { xs: 8, sm: 4, md: 4, lg: 4 },
        },
      ]
    }
  },
  {
    dutchId: 'omschrijving_kosten_2',
    questionType: QUESTION_TYPE.TEXT,
    fieldDisplayPosition: Tabs.FINAL_BUDGET + "." + SectionKeys.PURCHASE_PER_UNIT,
    groupItems: {
      id: "omschrijving_kosten_2",
      questions: [
        {
          dutchId: 'omschrijving_kosten_2',
          fieldId:'costDescription2',
          defaultValue : value?.costDescription2 ?? "",
          label: `${t("buyersGuide.options.individualOption.costs")} 2`,
          isHidden: false,
          
          disable: true,  
          keyName:"costDescription2",
          questionType:QUESTION_TYPE.TEXT,
          sizes: { xs: 12, sm: 6, md: 6, lg: 6 },
        },
        {
          dutchId: 'percentage_kosten_2 ',
          fieldId:'costPercentage2',
          label: t('general.per'),
          defaultValue : value?.costPercentage2 ?? 0,
          questionType: QUESTION_TYPE.NUMBER,
          isAllowedFn: isPercentageValue,
          isHidden: false,
          
          disable: false,
          keyName: 'costPercentage2',
          sizes: { xs: 4, sm: 2, md: 2, lg: 2 },
        },
         {
          dutchId: 'bedrag_kosten_2 ',
          fieldId:'costAmount2',
          label: t('general.price'),
          defaultValue : value?.costAmount2 ?? 0,
          questionType: QUESTION_TYPE.NUMBER,
          isHidden: false,
          
          disable: true,
          keyName: 'costAmount2',
          sizes: { xs: 8, sm: 4, md: 4, lg: 4 },
        },
      ]
    }
  },
  {
    dutchId: 'omschrijving_kosten_3',
    fieldDisplayPosition: Tabs.FINAL_BUDGET + "." + SectionKeys.PURCHASE_PER_UNIT,
    groupItems: {
      id: "omschrijving_kosten_3",
      questions: [
        {
          dutchId: 'omschrijving_kosten_3',
          fieldId:'costDescription3',
          defaultValue : value?.costDescription3 ?? "",
          label: `${t("buyersGuide.options.individualOption.costs")} 3`,
          isHidden: false,
          
          disable: true,
          keyName:"costDescription3",
          questionType:QUESTION_TYPE.TEXT,
          sizes: { xs: 12, sm: 6, md: 6, lg: 6 },
        },
        {
          dutchId: 'percentage_kosten_3 ',
          label: t('general.per'),
          fieldId:'costPercentage3',
          defaultValue : value?.costPercentage3 ?? 0,
          questionType: QUESTION_TYPE.NUMBER,
          isAllowedFn: isPercentageValue,
          isHidden: false,
          
          disable: false,
          keyName: 'costPercentage3',
          type:'number',
          sizes: { xs: 4, sm: 2, md: 2, lg: 2 },
        },
         { 
          dutchId: 'bedrag_kosten_3 ',
          label: t('general.price'),
          fieldId:'costAmount3',
          defaultValue : value?.costAmount3 ?? 0,
          questionType: QUESTION_TYPE.NUMBER,
          type:'number',
          isHidden: false,
          
          disable: true,
          keyName: 'costAmount3',
          sizes: { xs: 8, sm: 4, md: 4, lg: 4 },
        },
      ]
    }
  },

  {
    dutchId: 'omschrijving_kosten_4',
    fieldDisplayPosition: Tabs.FINAL_BUDGET + "." + SectionKeys.PURCHASE_PER_UNIT,
    groupItems: {
      id: "omschrijving_kosten_4",
      questions: [
        {
          dutchId: 'omschrijving_kosten_4',
          fieldId:'costDescription4',
          defaultValue : value?.costDescription4 ?? "",
          label: `${t("buyersGuide.options.individualOption.costs")} 4`,
          isHidden: false,
          
          disable: true,
          keyName:"costDescription4",
          questionType:QUESTION_TYPE.TEXT,
          sizes: { xs: 12, sm: 6, md: 6, lg: 6 },
        },
        {
          dutchId: 'percentage_kosten_4 ',
          fieldId:'costPercentage4',
          defaultValue : value?.costPercentage4 ?? 0,
          label: t('general.per'),
          questionType: QUESTION_TYPE.NUMBER,
          isAllowedFn: isPercentageValue,
          type:'number',
          isHidden: false,
          
          disable: false,
          keyName: 'costPercentage4',
          sizes: { xs: 4, sm: 2, md: 2, lg: 2 },
        },
         {
          dutchId: 'bedrag_kosten_4 ',
          fieldId:'costAmount4',
          label: t('general.price'),
          defaultValue : value?.costAmount4 ?? 0,
          questionType: QUESTION_TYPE.NUMBER,
          type:'number',
          isHidden: false,
          
          disable: true,
          keyName: 'costAmount4',
          sizes: { xs: 8, sm: 4, md: 4, lg: 4 },
        },
      ]
    }
  },
  {
    dutchId: 'omschrijving_kosten_5',
    fieldDisplayPosition: Tabs.FINAL_BUDGET + "." + SectionKeys.PURCHASE_PER_UNIT,
    groupItems: {
      id: "omschrijving_kosten_5",
      questions: [
        {
          dutchId: 'omschrijving_kosten_5',
          fieldId:'costDescription5',
          defaultValue : value?.costDescription5 ?? "",
          label: `${t("buyersGuide.options.individualOption.costs")} 5`,
          isHidden: false,
          
          disable: true,
          keyName:"costDescription5",
          questionType:QUESTION_TYPE.TEXT,
          sizes: { xs: 12, sm: 6, md: 6, lg: 6 },
        },
        {
          dutchId: 'percentage_kosten_5 ',
          fieldId:'costPercentage5',
          label: t('general.per'),
          defaultValue : value?.costPercentage5 ?? 0,
          questionType: QUESTION_TYPE.NUMBER,
          isAllowedFn: isPercentageValue,
          type:'number',
          isHidden: false,
          
          disable: false,
          keyName: 'costPercentage5',
          sizes: { xs: 4, sm: 2, md: 2, lg: 2 },
        },
         {
          dutchId: 'bedrag_kosten_5',
          fieldId:'costAmount5',
          label: t('general.price'),
          defaultValue : value?.costAmount5 ?? 0,
          questionType: QUESTION_TYPE.NUMBER,
          type:'number',
          isHidden: false,
          
          disable: true,
          keyName: 'costAmount5',
          sizes: { xs: 8, sm: 4, md: 4, lg: 4 },
        },
      ]
    }
  },
  {
    dutchId: 'totaal_bedrag_kosten',
    fieldId:'totalCostAmount',
    label: t("buyersGuide.options.individualOption.totalCosts"),
     defaultValue : value?.totalCostAmount ?? 0,
    questionType: QUESTION_TYPE.NUMBER,
    isHidden: false,
    
    disable: true,
    fieldDisplayPosition: Tabs.FINAL_BUDGET + "." + SectionKeys.PURCHASE_PER_UNIT,
      keyName: 'totalCostAmount',
    sizes:{xs: 12, sm: 4, md: 4, lg: 4}
  },
  {
    dutchId: 'resultaat',
    fieldId:'result',
    label: t("buyersGuide.options.individualOption.result"),
    questionType: QUESTION_TYPE.NUMBER,
    defaultValue : value?.result ?? 0,
    isHidden: false,
    
    disable: true,
    fieldDisplayPosition: Tabs.FINAL_BUDGET + "." + SectionKeys.PURCHASE_PER_UNIT,
    keyName: 'result',
    sizes:{xs: 12, sm: 4, md: 4, lg: 4}
  },
  // RIGHT SIDE 
  {
    dutchId: 'verkoopbedrag_incl_btw',
    fieldId:'salesPriceInclVAT',
    label: t('buyersGuide.standardOptions.salesPriceInclVAT'),
     defaultValue : value?.salesPriceInclVAT ?? 0,
    questionType: QUESTION_TYPE.NUMBER,
    isHidden: false,
    
    disable: true,
    fieldDisplayPosition: Tabs.FINAL_BUDGET + "." + SectionKeys.SALES_TOTAL,
    keyName: 'salesPriceInclVAT',
    sizes:{xs: 12, sm: 4, md: 4, lg: 4}
  },
  {
    dutchId: 'verkoopbedrag_excl_btw',
    fieldId:'salesAmountExclVAT',
    label: t('buyersGuide.standardOptions.salesPriceExclVAT'),
    defaultValue : value?.salesPriceExclVAT ?? 0,
    questionType: QUESTION_TYPE.NUMBER,
    isHidden: false,
    
    disable: true,
    fieldDisplayPosition: Tabs.FINAL_BUDGET + "." + SectionKeys.SALES_TOTAL,
    keyName: 'salesAmountExclVAT',
    sizes:{xs: 12, sm: 4, md: 4, lg: 4}
  },
  {
    dutchId: 'resultaat_totaal',
    fieldId:'result',
    label: t('buyersGuide.options.individualOption.resultTotal'),
    defaultValue : value?.result ?? 0,
    questionType: QUESTION_TYPE.NUMBER,
    isHidden: false,
    
    disable: true,
    fieldDisplayPosition: Tabs.FINAL_BUDGET + "." + SectionKeys.SALES_TOTAL,
    keyName: 'result',
    sizes:{xs: 12, sm: 4, md: 4, lg: 4}
  },
  // ---------- 4th TAB: TECH INFO ----------
  {
    dutchId: 'ingevoerd_op',
    fieldId:'createdOn',
    label: t('general.insertedOn'),
    questionType: QUESTION_TYPE.TEXT,
    defaultValue: value?.createdOn ?? "",
    isHidden: false,
    disable: true,
    fieldDisplayPosition: Tabs.TECH_INFO,
    keyName: 'createdOn',
  },
  {
    dutchId: 'ingevoerd_door',
    fieldId:'createdBy',
    label: t('general.insertedBy'),
    questionType: QUESTION_TYPE.TEXT,
    defaultValue: value?.createdBy ?? "",
    isHidden: false,
    
    disable: true,
    fieldDisplayPosition: Tabs.TECH_INFO,
    keyName: 'createdBy',
  },
  {
    dutchId: 'gewijzigd_op',
    label: t('general.modifiedOn'),
    questionType: QUESTION_TYPE.TEXT,
    defaultValue: value?.modifiedOn ?? "",
    isHidden: false,
    
    disable: true,
    fieldDisplayPosition: Tabs.TECH_INFO,
    keyName: 'modifiedOn',
  },
  {
    dutchId: 'gewijzigd_door',
    label: t('general.modifiedBy'),
    questionType: QUESTION_TYPE.TEXT,
    defaultValue: value?.modifiedBy ?? "",
    isHidden: false,
    
    disable: true,
    fieldDisplayPosition: Tabs.TECH_INFO,
    keyName: 'modifiedBy',
  },
  {
    dutchId: 'primary_key',
    label: t('general.primaryKey'),
    questionType: QUESTION_TYPE.TEXT,
    defaultValue: value?.id ?? "",
    isHidden: false,
    
    disable: true,
    fieldDisplayPosition: Tabs.TECH_INFO,
    keyName: 'id',
  },
]};

// Field calculation configurations
export const getFieldCalculations = () => [
  {
    targetField: 'salesAmountExclVAT',
    dependencies: ['percentageVAT', 'salesPriceInclVAT'],
    calculate: (values) => {
      const percentage = parseFloat(values.percentageVAT) || 0;
      const salesPriceIncl = parseFloat(values.salesPriceInclVAT) || 0;
      
      if (salesPriceIncl > 0 && percentage > 0) {
        return (salesPriceIncl / (1 + percentage / 100)).toFixed(2);
      }
      return '0';
    }
  },
  {
    targetField: 'VATAmount',
    dependencies: ['percentageVAT', 'salesPriceInclVAT'],
    calculate: (values) => {
      const percentage = parseFloat(values.percentageVAT) || 0;
      const salesPriceIncl = parseFloat(values.salesPriceInclVAT) || 0;
      
      if (salesPriceIncl > 0 && percentage > 0) {
        const salesAmountExcl = salesPriceIncl / (1 + percentage / 100);
        return (salesPriceIncl - salesAmountExcl).toFixed(2);
      }
      return '0';
    }
  },
  {
    targetField: 'surchargeAmount1',
    dependencies: ['salesAmountExclVAT', 'surchargePercentage1'],
    calculate: (values) => {
      const salesAmountExcl = parseFloat(values.salesAmountExclVAT) || 0;
      const surchargePercentage = parseFloat(values.surchargePercentage1) || 0;
      
      if (salesAmountExcl > 0 && surchargePercentage > 0) {
        return (salesAmountExcl * (surchargePercentage / 100)).toFixed(2);
      }
      return '0';
    }
  },
  {
    targetField: 'surchargeAmount2',
    dependencies: ['salesAmountExclVAT', 'surchargePercentage2'],
    calculate: (values) => {
      const salesAmountExcl = parseFloat(values.salesAmountExclVAT) || 0;
      const surchargePercentage = parseFloat(values.surchargePercentage2) || 0;
      
      if (salesAmountExcl > 0 && surchargePercentage > 0) {
        return (salesAmountExcl * (surchargePercentage / 100)).toFixed(2);
      }
      return '0';
    }
  },
  {
    targetField: 'totalSurchargeAmount',
    dependencies: ['salesAmountExclVAT', 'surchargePercentage1', 'surchargePercentage2'],
    calculate: (values) => {
      const salesAmountExcl = parseFloat(values.salesAmountExclVAT) || 0;
      const surchargePercentage1 = parseFloat(values.surchargePercentage1) || 0;
      const surchargePercentage2 = parseFloat(values.surchargePercentage2) || 0;
      
      const surchargeAmount1 = salesAmountExcl > 0 && surchargePercentage1 > 0 
        ? salesAmountExcl * (surchargePercentage1 / 100) 
        : 0;
      const surchargeAmount2 = salesAmountExcl > 0 && surchargePercentage2 > 0 
        ? salesAmountExcl * (surchargePercentage2 / 100) 
        : 0;
      
      return (surchargeAmount1 + surchargeAmount2).toFixed(2);
    }
  },
  {
    targetField: 'customSalesPrice',
    dependencies: ['salesAmountExclVAT', 'surchargePercentage1', 'surchargePercentage2'],
    calculate: (values) => {
      const salesAmountExcl = parseFloat(values.salesAmountExclVAT) || 0;
      const surchargePercentage1 = parseFloat(values.surchargePercentage1) || 0;
      const surchargePercentage2 = parseFloat(values.surchargePercentage2) || 0;
      
      const surchargeAmount1 = salesAmountExcl > 0 && surchargePercentage1 > 0 
        ? salesAmountExcl * (surchargePercentage1 / 100) 
        : 0;
      const surchargeAmount2 = salesAmountExcl > 0 && surchargePercentage2 > 0 
        ? salesAmountExcl * (surchargePercentage2 / 100) 
        : 0;
      
      return (salesAmountExcl - (surchargeAmount1 + surchargeAmount2)).toFixed(2);
    }
  },
  ...Array.from({ length: 5 }, (_, i) => ({
    targetField: `costAmount${i + 1}`,
    dependencies: ['baseCostAmount', `costPercentage${i + 1}`],
    calculate: (values) => {
      const baseCost = parseFloat(values.baseCostAmount) || 0;
      const costPercentage = parseFloat(values[`costPercentage${i + 1}`]) || 0;
      
      if (baseCost > 0 && costPercentage > 0) {
        return (baseCost * (costPercentage / 100)).toFixed(2);
      }
      return '0';
    }
  })),
  {
    targetField: 'totalCostAmount',
    dependencies: ['baseCostAmount', 'costPercentage1', 'costPercentage2', 'costPercentage3', 'costPercentage4', 'costPercentage5'],
    calculate: (values) => {
      const baseCost = parseFloat(values.baseCostAmount) || 0;
      
      const totalCost = [1, 2, 3, 4, 5].reduce((sum, i) => {
        const costPercentage = parseFloat(values[`costPercentage${i}`]) || 0;
        return sum + (baseCost > 0 && costPercentage > 0 ? baseCost * (costPercentage / 100) : 0);
      }, 0);
      
      return totalCost.toFixed(2);
    }
  },
  {
    targetField: 'result',
    dependencies: ['salesAmountExclVAT', 'surchargePercentage1', 'surchargePercentage2', 'baseCostAmount', 'costPercentage1', 'costPercentage2', 'costPercentage3', 'costPercentage4', 'costPercentage5'],
    calculate: (values) => {
      const salesAmountExcl = parseFloat(values.salesAmountExclVAT) || 0;
      const surchargePercentage1 = parseFloat(values.surchargePercentage1) || 0;
      const surchargePercentage2 = parseFloat(values.surchargePercentage2) || 0;
      const baseCost = parseFloat(values.baseCostAmount) || 0;
      
      const surchargeAmount1 = salesAmountExcl > 0 && surchargePercentage1 > 0 
        ? salesAmountExcl * (surchargePercentage1 / 100) 
        : 0;
      const surchargeAmount2 = salesAmountExcl > 0 && surchargePercentage2 > 0 
        ? salesAmountExcl * (surchargePercentage2 / 100) 
        : 0;
      
      const customSalesPrice = salesAmountExcl - (surchargeAmount1 + surchargeAmount2);
      
      const totalCostAmount = [1, 2, 3, 4, 5].reduce((sum, i) => {
        const costPercentage = parseFloat(values[`costPercentage${i}`]) || 0;
        return sum + (baseCost > 0 && costPercentage > 0 ? baseCost * (costPercentage / 100) : 0);
      }, 0);
      
      return (customSalesPrice - (baseCost + totalCostAmount)).toFixed(2);
    }
  },
];
